import {Component, Vue} from 'vue-property-decorator'
import {uuidv4} from "@/design-system/utilities/Uuid"

let uidCounter = 1;

@Component
export default class UniqueIdMixin extends Vue {
    protected $_id = 0;

    created () {
        if (!this.$_id) this._initializeUid()
    }

    _initializeUid() {
        uidCounter++;
        this.$_id = uidCounter
    }

    $id (suffix: string = '') {
        if (!this.$_id) this._initializeUid()
        return 'jdsUID-' + this.$_id + suffix;
    }
}
